import { fork, all } from 'redux-saga/effects';

const combineSagas = (sagas) =>
  function*() {
    yield all(sagas.map(fork));
  };

export default combineSagas;
